import React, { Component } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'moment/locale/es';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { fetchHolidays, fetchJornadaLaboral, fetchJornadaLaboralByMonth, fetchJornadaLaboralDet, fetchReminders, getEventColor } from 'services/justificaciones';
import { PropsCalendario, State } from 'components/Types/GeneralTypes';
import moment from 'moment-timezone';
import JornadaCard from 'components/Varios/Cards/JornadaCard';
import './CalendarStyles.scss';
import ModalSimple from 'components/Varios/Modals/ModalSimple';
import Cargando from 'components/Varios/Cargando';
import CustomEvent from './CustomEvent';
import EventContext from 'Context/EventContext';
import Toolbar from './Toolbar';
import { IconColorProvider } from 'Context/IconColorContext';

moment.updateLocale('es', {
    week: {
        dow: 0,
    }
});
moment.tz.setDefault('America/Guayaquil');
const localizer = momentLocalizer(moment);
class CalendarComponent extends Component<PropsCalendario, State> {

    state: State = {
        events: [],
        date: new Date(),
        selectedEvent: null,
        styledDays: new Map(),
        showModal: false,
        loading: false,
        error: false,
        isMounted: true,
        errorMessage: '',
        loadingModalContent: false,
        tipoJornada: '',
        nonWorkingDays:[]
    };

    componentDidMount() {
        this.setState({ isMounted: true });
        this.fetchData();
    }

    componentWillUnmount() {
        this.setState({ isMounted: false });
    }

    componentDidUpdate(prevProps) {
        // Comprueba si las props relevantes han cambiado
        if (prevProps.cedula !== this.props.cedula || prevProps.month !== this.props.month || prevProps.year !== this.props.year) {
            // Si hay cambios en cedula, month o year, llama a fetchData para recargar los datos
            this.fetchData();
        }
    }
    fetchData = () => {
        this.setState({ loading: true, error: false });
        const { cedula, month, year } = this.props;
        let fetchJornadaPromise;
        var fechaConsulta = new Date();
        if (month != null && year != null) {
            // Si month y year tienen valor, llama a fetchJornadaLaboralByMonth
            fetchJornadaPromise = fetchJornadaLaboralByMonth(cedula, month, year);
            fechaConsulta = new Date(year,month  ,0,0,0,0,0);
        } else {
            // De lo contrario, llama a fetchJornadaLaboral
            fetchJornadaPromise = fetchJornadaLaboral(cedula);
        }
        Promise.all([
            fetchJornadaPromise,
            fetchReminders(), 
            fetchHolidays()
        ]).then(([jornadaData, reminderData, holidaysData]) => {
            if (!jornadaData || jornadaData.length === 0) {
                this.setState({ loading: false, error: true });
                return;
            }
            if (this.state.isMounted) {
                const jornadaEvents = jornadaData.map(item => {
                    const eventDate = new Date(item.fecha);
                    const isWeekend = item.finSemanaFeriado;
                    const events = [{
                        title: "Jornada Laboral",
                        start: eventDate,
                        end: eventDate,
                        allDay: true,
                        color: getEventColor(item.jornada.tipo),
                        tipo: item.jornada.tipo,
                        jornada: item,
                        tipoJornada: "L"
                    }];

                    if (!isWeekend && item.receso) {
                        events.push({
                            title: "Receso",
                            start: eventDate,
                            end: eventDate,
                            allDay: true,
                            color: getEventColor(item.receso.tipo),
                            tipo: item.receso.tipo,
                            jornada: item,
                            tipoJornada: "R"
                        });
                    }
                    return events;
                }).flat();

                const reminderEvents = reminderData.map(item => {
                    const eventDate = new Date(item.fechaRecuperacion);
                    const events = [
                        {
                            title: "Recordatorio",
                            start: eventDate,
                            end: eventDate,
                            allDay: true,
                            color: getEventColor(item.tipo),
                            tipo: 9,
                            jornada: item,
                            tipoJornada: "C"
                        }
                    ];
                    return events;
                }).flat();
                this.setState({
                    events: [...reminderEvents, ...jornadaEvents],
                    loading: false,
                    nonWorkingDays:holidaysData,

                });
                if(month != null && year != null) {
                    this.setState({
                        date :fechaConsulta
                    });
                }

                
            }
        }).catch((error) => {
            if (this.state.isMounted) {
                this.setState({ loading: false, error: true });
            }
        });
    }

    updateEvents = () => {
        this.fetchData();
    }
    eventStyleGetter = (event) => {
        let backgroundColor = 'transparent';
        return {
            style: {
                borderRadius: "0px",
                color: 'black',
                border: '1px',
                display: 'block',
                backgroundColor
            }
        }
    };
    renderToolbar = ({ label, onNavigate, canNavigate }) => {
        if (!canNavigate) {
            return null;
        }
    
        // Si canNavigate es true, renderizamos la toolbar normalmente
        return (
            <div className="rbc-toolbar">
                <span className="rbc-btn-group">
                    <button type="button" onClick={() => onNavigate('PREV')}> &lt; </button>
                </span>
                <span className="rbc-toolbar-label">{label}</span>
                <span className="rbc-btn-group">
                    <button type="button" onClick={() => onNavigate('NEXT')}> &gt; </button>
                </span>
            </div>
        );
    }
    

    dayPropGetter = (date) => {
        const isNonWorkingDay = this.state.nonWorkingDays.some(nonWorkingDay => nonWorkingDay.toDateString() === date.toDateString());
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;

        return {
            className: isNonWorkingDay || isWeekend ? 'weekend' : ''
        };
    };
    onSelectEvent = async (event) => {
        const { month, year } = this.props;
        this.setState({ loadingModalContent: true });
        if (event.tipoJornada === 'C') {
            this.setState({
                selectedEvent: event,
                showModal: true,
                loadingModalContent: false,
                tipoJornada: event.tipoJornada,
            });
            return;
        }
        if (month != null && year != null) {
            this.setState({
                selectedEvent: event.jornada,
                showModal: true,
                loadingModalContent: false,
                tipoJornada: event.tipoJornada,
            });
            return;
        }
        try {
            const detailedJornada = await fetchJornadaLaboralDet(event.jornada.idJornada);
            if (this.state.isMounted) {

                this.setState({
                    selectedEvent: detailedJornada,
                    showModal: true,
                    loadingModalContent: false,
                    tipoJornada: event.tipoJornada,
                });
            }
        } catch (error) {
            let errorMessage = 'No es posible mostrar el detalle de la jornada por ahora.';
            if (error instanceof Error && error.message.includes('Error al obtener el detalle de la jornada')) {
                errorMessage = error.message;
            }
            this.setState({
                showModal: true,
                errorMessage: errorMessage,
                selectedEvent: null,
                loadingModalContent: false
            });
        }
    };

    closeModal = () => this.setState({ showModal: false, errorMessage: '' });

    onNavigate = (action) => {

        if (this.props.canNavigate !== undefined && this.props.canNavigate === false) {
            ;
        }   
        else {
            const currentMonth = new Date();
            const previousMonth = new Date(new Date().setMonth(currentMonth.getMonth() - 1));

            let newDate = new Date(this.state.date);

            if (action === 'PREV') {
                if (newDate.getMonth() === currentMonth.getMonth() && newDate.getFullYear() === currentMonth.getFullYear()) {
                    newDate.setMonth(newDate.getMonth() - 1);
                }
            } else if (action === 'NEXT') {
                if (newDate.getMonth() === previousMonth.getMonth() && newDate.getFullYear() === previousMonth.getFullYear()) {
                    newDate.setMonth(newDate.getMonth() + 1);
                }
            }

            this.setState({ date: newDate });
        }

    }
    render() {
        const{canNavigate}= this.props;
        const { events, date, selectedEvent, showModal, loading, error, errorMessage } = this.state;
        if (loading) {
            return <Cargando />;
        }

        if (error) {
            return <div>Lo sentimos, por ahora no se puede cargar el calendario de jornada laboral.</div>;
        }

        const messages = {
            allDay: 'Todo el día',
            previous: '<',
            next: '>',
            day: 'Día',
            date: 'Fecha',
            time: 'Hora',
            event: 'Evento',
            showMore: total => `+ Ver más (${total})`
        };

        return (
            <IconColorProvider>
                <EventContext.Provider value={{ updateEvents: this.updateEvents }}>
                    <Toolbar />

                    <div >
                        <Calendar
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 800 }}
                            views={['month']}
                            messages={messages}
                            onSelectEvent={this.onSelectEvent}
                            eventPropGetter={this.eventStyleGetter}
                            onNavigate={this.onNavigate}
                            date={date}
                            dayPropGetter={this.dayPropGetter}
                            components={{
                                event: props => <CustomEvent {...props} getEventColor={getEventColor} />,
                                toolbar: props => this.renderToolbar({ ...props, onNavigate: this.onNavigate , canNavigate:canNavigate}),

                            }}
                        />

                        <ModalSimple isOpen={showModal || this.state.loadingModalContent} onClose={this.closeModal}>
                            {this.state.loadingModalContent ? <Cargando /> :
                                (this.state.errorMessage ? <div>{this.state.errorMessage}</div>
                                    : <JornadaCard jornadaLaboral={this.state.selectedEvent} tipo={this.state.tipoJornada} onClose={this.closeModal} />)}
                        </ModalSimple>

                    </div>
                </EventContext.Provider>
            </IconColorProvider>

        );
    }
}

export default CalendarComponent;
